/**
 * Created with JetBrains WebStorm.
 * User: leafpan
 * Date: 2026/5/7.
 * To change this template use File | Settings | File Templates.
 */

import request from '@/utils/request'

export function getMemberListApi(data) {
  return request({
    url: '/api/memberarchives',
    method: 'post',
    data
  })
}

export function getMemberDetailApi(id) {
  return request({
    url: `/api/memberarchive/${id}`,
    method: 'get',
  })
}

export function getIndustryFieldApi() {
  return request({
    url: `/api/dicts/industry_field`,
    method: 'get',
  })
}

export function getRichtextListApi(data) {
  return request({
    url: '/api/richtext/richtexts',
    method: 'post',
    data
  })
}

export function getRichtextDetailApi(id) {
  return request({
    url: `/api/richtext/id/${id}`,
    method: 'get',
  })
}
